/* eslint-disable @typescript-eslint/no-shadow */
import { staffStrings } from '@data/staff';
import { requiredStringField, stringField } from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const profile = t.type({
  avatar: t.string,
  avatar_sm: t.string,
});

export type Profile = t.TypeOf<typeof profile>;

export const baseUser = t.type({
  email: t.string,
  last_name: t.string,
  first_name: t.string,
  role: t.string,
});

export type BaseUser = t.TypeOf<typeof baseUser>;

export const adminUser = t.type({
  ...baseUser.props,
  id: t.number,
  cellphone: t.string,
  last_login: h.omittable(t.string),
  landline: t.string,
  sns_id: t.string,
  email_verified: t.boolean,
});

export type AdminUser = t.TypeOf<typeof adminUser>;

export const patchCompanyPrincipal = t.partial(adminUser.props);

export type PatchCompanyPrincipal = t.TypeOf<typeof patchCompanyPrincipal>;

export const user = t.type({
  ...adminUser.props,
  display_name: t.string,
  date_joined: t.string,
  cellphone: t.string,
  email_verified: t.boolean,
  staff_id: t.string,
  is_staff: t.boolean,
  is_superuser: t.boolean,
  is_principal: t.boolean,
  profile,
  agency_id: h.omittable(t.number),
});

export type User = t.TypeOf<typeof user>;

export const companyStaffBase = t.type({
  email: t.string,
  last_name: h.omittable(t.string),
  first_name: h.omittable(t.string),
  cellphone: h.omittable(t.string),
  landline: h.omittable(t.string),
});

export type CompanyStaffBase = t.TypeOf<typeof companyStaffBase>;

export const companyStaff = t.type({
  id: t.number,
  ...companyStaffBase.props,
  email_verified: h.omittable(t.boolean),
});

export type CompanyStaff = t.TypeOf<typeof companyStaff>;

export const patchCompanyStaff = t.partial(companyStaffBase.props);

export type PatchCompanyStaff = t.TypeOf<typeof patchCompanyStaff>;

export const minimumUser = t.type({
  email: t.string,
  last_name: h.omittable(t.string),
  first_name: h.omittable(t.string),
});

export type MinimumUser = t.TypeOf<typeof minimumUser>;
export class UserHelper {
  constructor(public user: BaseUser) {}

  get shortName() {
    return this.user.last_name;
  }

  get fullname() {
    return `${this.user.last_name} ${this.user.first_name}`.trim();
  }

  get isFCJapan() {
    return this.user.role === 'FCJapan';
  }

  get isAdmin() {
    return this.user.role === 'admin';
  }

  get isJapanStaff() {
    return this.isFCJapan || this.isAdmin;
  }

  get isFCChina() {
    return this.user.role === 'FCChina';
  }
}

export const dashboardUsersQuery = t.partial({
  page: h.number().cast(),
  page_size: h.number().cast(),
  company_name: t.string,
  date_joined_before: t.string,
  date_joined_after: t.string,
  email: t.string,
  emails: t.array(t.string),
  ordering: t.array(t.string),
  login_status: t.string,
  selected: t.array(t.number),
});

export type DashboardUsersQuery = t.TypeOf<typeof dashboardUsersQuery>;

export const dashboardMemberStaffForm = t.type({
  email: requiredStringField(staffStrings.email),
  last_name: requiredStringField(staffStrings.last_name),
  first_name: requiredStringField(staffStrings.first_name),
  cellphone: stringField(staffStrings.cellphone),
  landline: stringField(staffStrings.landline),
});
